import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IQuesField } from '../multi-section-form-preview.models';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview.service';
import { EvalScriptPipe } from '../../../shared/eval-script.pipe';
import { SafeHtmlPipe } from '../../../services/safe-html.pipe';
import { RecognizeInputDirective } from '../recognize-input.directive';
import { BuyerPreviewService } from '../../buyer-preview.service';


@Component({
    selector: 'app-label-response-guidance',
    templateUrl: './label-response-guidance.component.html',
    styleUrls: ['./label-response-guidance.component.css'],
    standalone: true,
    imports: [
    RecognizeInputDirective,
    SafeHtmlPipe,
    EvalScriptPipe
],
})
export class LabelResponseGuidanceComponent implements OnInit, OnDestroy {
  @Input() fieldPreview: any;
  public msfps = inject(MultiSectionFormPreviewService);
  public buyerPreviewService = inject(BuyerPreviewService)
  mode = localStorage.getItem('mode')
  surveyRefID = localStorage.getItem('SurveyId')
  placeholderList: any[] = [];
  private _placeholderSub?: Subscription;

  ngOnInit(): void {
    // Subscribe to reactive placeholder list to ensure placeholders are resolved
    // even when HTTP response arrives after component initialization (SM-3309)
    this._placeholderSub = this.buyerPreviewService.placeholderList$.subscribe(list => {
      this.placeholderList = list;
    });
  }

  ngOnDestroy(): void {
    this._placeholderSub?.unsubscribe();
  }

  replacePlaceholdersInText(fieldText: string) {
    this.placeholderList.forEach(placeholder => {
      const placeholderTag = `{{# ${placeholder.key} #}}`;
      fieldText = fieldText?.replaceAll(placeholderTag, placeholder.value);
    });
    return fieldText;
  }

  getFieldLabel(field: IQuesField) {
    return field.data.find((f) => f.type?.toLowerCase() === 'text');
  }
  getFieldResponse(field: IQuesField) {
    return field.data.find((f) => f.type?.toLowerCase() !== 'text');
  }
  getFieldGuidance(field: IQuesField) {
    return field.data.find((f) => f.type?.toLowerCase() === 'guidance');
  }
  downloadFormQuestionAttachment(id: any, fileName: any){
    console.log('Download params:', { id, fileName, surveyRefID: this.surveyRefID });
    this.buyerPreviewService.downloadFormQuestionAttachment(id, fileName, this.surveyRefID).subscribe((blob: any) => {
      this.buyerPreviewService.saveFile(blob, fileName);
    }, error => {});
    }

    removeFormQuestionAttachment(id: any, fileName: any){
      this.fieldPreview.nodeLogic.selectedAnswers = []
      this.fieldPreview.answered = false
      }
 
  downloadFileFromHex(input: any, filename: string) {
    const byteArray = input; 
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename; 
    a.click(); 
    window.URL.revokeObjectURL(url);
  }
}
